import { useRef, useState, useEffect } from 'react';

export default function CertSection() {
  const ref = useRef<HTMLElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setIsVisible(true); observer.unobserve(el); } },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const listItems = [
    { icon: 'ri-shield-check-line', text: '보건복지부 정식 인가 단체 발급 자격증' },
    { icon: 'ri-award-line', text: '반영구문신, 눈썹, 아이라인, 입술, SMP전문가' },
    { icon: 'ri-file-text-line', text: '위생교육 알선, 이수증 발급 및 창업 컨설팅 지원' },
    { icon: 'ri-global-line', text: '국내외 활동 가능한 공신력 있는 자격 인증' },
  ];

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-16 md:py-24 bg-[#F4F6FA]">
      <div className="max-w-7xl mx-auto px-5 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
          <div className={`text-center lg:text-left anim-slide-left ${isVisible ? 'is-visible' : ''}`}>
            <span className="inline-block text-xs font-bold tracking-widest text-[#C9A84C] uppercase border border-[#C9A84C]/40 rounded-sm px-3 py-1 mb-6">Certification</span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-[#1B3A6B] mb-6 leading-tight">
              본회 공식<br /><span className="text-[#C9A84C]">자격증 발급</span> 기관
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-8">
              대한문신사중앙회는 보건복지부 정식 인가를 받은 공식 단체입니다.
              중구지부에서 교육 수료 후 본회 공식 자격증을 취득하여 전문 아티스트로서의
              공신력을 갖추세요.
            </p>
            <ul className="space-y-4 mb-10 text-left">
              {listItems.map((item, i) => (
                <li
                  key={item.text}
                  className={`flex items-start gap-3 anim-fade-up ${isVisible ? 'is-visible' : ''}`}
                  style={{ transitionDelay: isVisible ? `${200 + i * 80}ms` : '0ms' }}
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#1B3A6B]/10 text-[#1B3A6B] flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-sm`} />
                  </div>
                  <span className="text-gray-700 text-sm leading-relaxed">{item.text}</span>
                </li>
              ))}
            </ul>
            <a href="/certification" className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-[#1B3A6B] text-white font-semibold hover:bg-[#15305a] transition-colors cursor-pointer w-full sm:w-auto">
              자격증 안내 보기 <i className="ri-arrow-right-line" />
            </a>
          </div>

          <div className={`relative anim-slide-right ${isVisible ? 'is-visible' : ''}`} style={{ transitionDelay: '150ms' }}>
            <div className="rounded-xl overflow-hidden w-full h-64 md:h-80 lg:h-96 border border-gray-100">
              <img
                src="https://public.readdy.ai/ai/img_res/d305cf1f49e32911aa8e1c031547edda.jpg"
                alt="대한문신사중앙회 공식 자격증"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 -right-4 bg-[#1B3A6B] text-white rounded-xl p-5">
              <p className="text-sm font-black text-[#C9A84C] leading-tight">대한문신사<br />중앙회</p>
              <p className="text-xs font-semibold mt-0.5">공식 인증 마크</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
